export default {
    region: "eu-west-1",
    // UserPoolId: "eu-west-1_NIO6GhDKW",
    // ClientId: "3sqensja2np6jljflijj2l7fn5"
    UserPoolId  : 'eu-west-1_xzsPbELD8',
    ClientId    : '4faovb6objih0ikocrvslc1bva',
};